module.exports = __webpack_public_path__ + "static/media/data_analyst_use_case_1.3601c4bf.svg";